import { Expose } from "class-transformer";

export class UpdateTemplateDto {
  @Expose()
  name?: string;

  @Expose()
  description?: string;
}
